export const CURRENCY = "SEK";
